import baseAPI from '@/http'

const router = 'api/pergunta/perguntapmd'

export const pmdAPI = {
  get: (id) => baseAPI.get(`${router}/get-pmd/${id}`),
  update: (payload) => baseAPI.put(`${router}/update-pmd`, payload)
}
